import { ControlType } from "./control-type.model";
import { VasBaseObjectApiFacade } from "../base-object/vas-base-object.api-facade";
import { Observable } from "rxjs/Observable";
import { ApiRequestOptions } from "../../../core/services/api/request-options";

export class ControlTypeApiFacade extends VasBaseObjectApiFacade<ControlType> {

    get(id: string, options?: ApiRequestOptions): Observable<ControlType> {
        return this.GET(`/controltypes/${id}`, options)
            .map(object => new ControlType(object));
    }

    getAll(options?: ApiRequestOptions): Observable<Array<ControlType>> {
        return this.CGET(`/controltypes`, options)
            .map(objects => objects.map(object => new ControlType(object)));
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/control-type/control-type.api-facade.ts